const getCountry = async (cb?: (country: string) => void): Promise<Record<string, string> | string> => {
  try {
    const res = await fetch('/browsing_context_suggestions.json');
    const body = await res.text();
    if (!body) {
      return {};
    }
    const data = JSON.parse(body);
    if (!data.detected_values || !data.detected_values.country) {
      return {};
    }
    const country = data.detected_values.country;
    window['blubolt'].geo = country;

    if (typeof cb === 'function') {
      cb(country);
    }
    return country;
  } catch (e) {
    return {};
  }
};

export default getCountry;